import Vue from 'vue';
import Router from 'vue-router';
import login from '@/components/account/login';
import homepage from '@/components/pages/homepage';
// 首页
import home from '@/components/views/home/home';
// 管理员
import admin from '@/components/views/admin/admin';
// 设备管理
import device from '@/components/views/device/device';

// 用户管理
import user from '@/components/views/user/user';
import userInfo from '@/components/views/user/userInfo';

// 学院管理
import tutorial from '@/components/views/tutorial/tutorial';
import tutorialList from '@/components/views/tutorial/tutorialList';
import tutorialCarousel from '@/components/views/tutorial/carousel';

// // 企业日志
import enterpriseLog from '@/components/views/log/enterpriseLog';


Vue.use(Router)

const router = new Router({
  // 去除URL # 号
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      component: login,
    },
    {
      path: '*',
      component: homepage,
      meta: {
        needLogin: true
      }, //需要登录 路由元信息
      children: [{
          // 首页
          path: '/home',
          component: home,
          meta: {
            needLogin: true
          }, //需要登录 路由元信息
        },
        {
          // 管理员
          path: '/admin',
          component: admin,
          meta: {
            needLogin: true
          }
        },
        {
          // 设备管理
          path: '/device',
          component: device,
          meta: {
            needLogin: true
          }
        },
        {
          // 用户管理
          path: '/user',
          component: user,
          meta: {
            needLogin: true
          }
        },
        {
          // 用户详情
          path: '/user/info',
          component: userInfo,
          meta: {
            needLogin: true
          }
        },
        {
          // 教程分类
          path: '/tutorial',
          component: tutorial,
          meta: {
            needLogin: true
          }
        },
        {
          // 教程列表
          path: '/tutorial/list',
          component: tutorialList,
          meta: {
            needLogin: true
          }
        },
        {
          // 轮播图管理
          path: '/tutorial/carousel',
          component: tutorialCarousel,
          meta: {
            needLogin: true
          }
        },
        {
          // 企业日志
          path: '/enterpriseLog',
          component: enterpriseLog,
          meta: {
            needLogin: true
          }
        }
      ]
    }
  ]
})

//导航守卫
router.beforeEach((to, from, next) => {
  console.log(to)
  //先把想去的路径保存起来  获取不是login的那个路径
  if (to.fullPath != '/login') { //利用被覆盖的特性,每次都只会记录到一个
    localStorage.setItem('toVisitPath', to.fullPath)
    //console.log("你想去的地方")
    // console.log(localStorage.getItem("toVisitPath"))
  }
  if (to.meta.needLogin) { //需要登录
    //通过发送请求给后台判断是否登录过  如果登录过 直接next
    //如果没有登录过,去登录组件
   //console.log("查下登录了没")
    if (sessionStorage.getItem("isLogin")) { //查下登录了没
      //console.log("查下登录了没")
      if(null != next && typeof(next) == 'function'){
        next()
      }
    } else { //如果没有登录
      router.push('/login')
    }
  } else { //直接导航到组件中去
    next()
  }

})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js